// eslint-disable-next-line @typescript-eslint/ban-types
export default function cloneDeep<V extends object | null | undefined>(
  value: V
) {
  return structuredClone(value)
}
